import React from "react";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFeatures } from "flagged";

import MasterLayout from "@layouts/MasterLayout.react";
import { Div, Image, Button } from "@components/Generics.react";
import { settings } from "@config/settings/app.settings";
import RecommendedArticles from "@components/RecommendedArticles.react";
import TermsPage from "./panels/TermsPage.react";
import ReactPlayer from "react-player/lazy";
import { Divider } from "semantic-ui-react";

export default function DesktopHome(props) {
    const user = useSelector((state) => state.auth.user);
    const { t } = useTranslation("common");
    const features = useFeatures();
    const isPortrait = window.innerHeight > window.innerWidth;
    // Feature flag controls whether the mobile restriction is enabled
    const showMobileRestriction = features.general.mobileDeviceRestrictions;

    const stages = settings.gamification.stages;
    const userStage = settings.home[user.stage || stages.length];

    const pageContent =
        user.license.termsAccepted || !features.general.acceptTerms ? (
            <Div fullht fluid flex top-aligned>
                <Div wd="calc(100% - 360px)" padSides>
                    <Div fluid flex top-aligned>
                        <Div wd="40%" altText huge uppercase>
                            <Div wd="40%" altText huge uppercase txtCharcoal>
                                Welcome{" "}
                            </Div>
                            {user.branding?.name
                                ? "to " + user.branding?.name
                                : ""}
                        </Div>
                        <Div wd="60%">
                            <Div
                                rounded
                                noOverflow
                                gutter
                                className="video-responsive"
                            >
                                <ReactPlayer
                                    className="react-player"
                                    url={user.branding?.homeVideo}
                                    width="100%"
                                    height="100%"
                                />
                            </Div>
                        </Div>
                    </Div>
                    <Divider />
                    <br />
                    <Div ash basepad>
                        <Div altText large uppercase gutter>
                            How it works:
                        </Div>
                        <ul>
                            <li>
                                Watch the video to understand how the simulation works.
                            </li>
                            <li>
                                You can track your progress and performance in the "Reports" section.
                            </li>
                            <li>
                                All the information you need to make decisions is available in the "Infobase" Section.
                            </li>
                            <li>
                                Click on "Start Simulation" to begin.
                            </li>
                        </ul>
                        <Button
                            primary
                            href="/library"
                            content="Start Simulation"
                        />
                    </Div>
                </Div>
                <Div wd="360px" fullht basepad peat rounded>
                    <Div gutter big uppercase altText>
                        Quick Links:
                    </Div>
                    <Div
                        relative
                        fluid
                        style={{ height: "0", paddingBottom: "133%" }}
                    >
                        {userStage &&
                            _.map(userStage.images, ({ src, coords }, idx) => {
                                return (
                                    <NavLink
                                        to={t(`home.links.${src}`)}
                                        key={`homeelm-${idx}`}
                                    >
                                        <Image
                                            src={t(`home.images.${src}`)}
                                            style={{
                                                position: "absolute",
                                                left: `${coords[0]}%`,
                                                top: `${coords[1]}%`,
                                                width: `${coords[2]}%`,
                                            }}
                                        />
                                    </NavLink>
                                );
                            })}
                    </Div>
                </Div>
            </Div>
        ) : (
            <TermsPage />
        );
    const mobileView = (
        <Div centered fluid fullht balanced>
            <Image
                src={user.branding?.homeImage || "/assets/images/configurable/lock.png"}
                fluid
            />
            <br />
            <Div altText massive gutter>Please Use a Desktop Device</Div>
            <Div altText large>
                This website is optimized for larger screens and may not work correctly on mobile devices.
                For the best experience, please view this site on a desktop or laptop computer.
            </Div>
        </Div>
    );

    // Show mobileView only when:
    // 1. Device is in portrait mode
    // 2. Mobile device restriction feature is enabled
    const shouldShowMobileView = isPortrait && showMobileRestriction;

    // ========================= Render Function =================================
    return (
        <MasterLayout
            title={"Welcome"}
            mainPanel={
                shouldShowMobileView ? mobileView : pageContent
            }
            rightPanelName={t(`components.recommended`)}
            rightPanel={<RecommendedArticles />}
            rootPage={true}
            hidePanelToggle
            startFullScreen={true}
        />
    );
}
